module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst attributes = model.nrOfElementsAttributes || {}\n%><table><%\n%><tbody><%\nif(config.showSelectedElements){\n%><tr><%\n%><td class=\"name\"><%= storage.__((config.translationPrefix || `ninjaModules.${model.ninjaModule || 'missingNinjaModule'}`) + '.summary.nrOfSelectedElements') %>:</td><%\n%><td class=\"value\"><%= model.nrOfSelectedElements || 0 %></td><%\n%></tr><%\n}\n%><tr><%\n%><td class=\"name\"><%= storage.__((config.translationPrefix || `ninjaModules.${model.ninjaModule || 'missingNinjaModule'}`) + '.summary.nrOfElements') %>:</td><%\n%><td class=\"value\"><%= attributes.nrOfVisibleElements || 0 %></td><%\n%></tr><%\n%><tr><%\n%><td class=\"name\"><%= storage.__((config.translationPrefix || `ninjaModules.${model.ninjaModule || 'missingNinjaModule'}`) + '.summary.nrOfMatchingElements') %>:</td><%\n%><td class=\"value\"><%= attributes.nrOfMatchingElements || 0 %></td><%\n%></tr><%\n%><tr class=\"row\"><%\n%><td class=\"name\"><%= storage.__((config.translationPrefix || `ninjaModules.${model.ninjaModule || 'missingNinjaModule'}`) + '.summary.nrOfAllElements') %>:</td><%\n%><td class=\"value\"><%= (attributes.nrOfElements || 0) %></td><%\n%></tr><%\n%></tbody><%\n%></table>"
  , __filename = "components/templates/ninja/table/summary.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const attributes = model.nrOfElementsAttributes || {}

    ; __line = 3
    ; __append("<table>")
    ; 

    ; __line = 4
    ; __append("<tbody>")
    ; 
if(config.showSelectedElements){

    ; __line = 6
    ; __append("<tr>")
    ; 

    ; __line = 7
    ; __append("<td class=\"name\">")
    ; __append(escapeFn( storage.__((config.translationPrefix || `ninjaModules.${model.ninjaModule || 'missingNinjaModule'}`) + '.summary.nrOfSelectedElements') ))
    ; __append(":</td>")
    ; 

    ; __line = 8
    ; __append("<td class=\"value\">")
    ; __append(escapeFn( model.nrOfSelectedElements || 0 ))
    ; __append("</td>")
    ; 

    ; __line = 9
    ; __append("</tr>")
    ; 
}

    ; __line = 11
    ; __append("<tr>")
    ; 

    ; __line = 12
    ; __append("<td class=\"name\">")
    ; __append(escapeFn( storage.__((config.translationPrefix || `ninjaModules.${model.ninjaModule || 'missingNinjaModule'}`) + '.summary.nrOfElements') ))
    ; __append(":</td>")
    ; 

    ; __line = 13
    ; __append("<td class=\"value\">")
    ; __append(escapeFn( attributes.nrOfVisibleElements || 0 ))
    ; __append("</td>")
    ; 

    ; __line = 14
    ; __append("</tr>")
    ; 

    ; __line = 15
    ; __append("<tr>")
    ; 

    ; __line = 16
    ; __append("<td class=\"name\">")
    ; __append(escapeFn( storage.__((config.translationPrefix || `ninjaModules.${model.ninjaModule || 'missingNinjaModule'}`) + '.summary.nrOfMatchingElements') ))
    ; __append(":</td>")
    ; 

    ; __line = 17
    ; __append("<td class=\"value\">")
    ; __append(escapeFn( attributes.nrOfMatchingElements || 0 ))
    ; __append("</td>")
    ; 

    ; __line = 18
    ; __append("</tr>")
    ; 

    ; __line = 19
    ; __append("<tr class=\"row\">")
    ; 

    ; __line = 20
    ; __append("<td class=\"name\">")
    ; __append(escapeFn( storage.__((config.translationPrefix || `ninjaModules.${model.ninjaModule || 'missingNinjaModule'}`) + '.summary.nrOfAllElements') ))
    ; __append(":</td>")
    ; 

    ; __line = 21
    ; __append("<td class=\"value\">")
    ; __append(escapeFn( (attributes.nrOfElements || 0) ))
    ; __append("</td>")
    ; 

    ; __line = 22
    ; __append("</tr>")
    ; 

    ; __line = 23
    ; __append("</tbody>")
    ; 

    ; __line = 24
    ; __append("</table>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/ninja/table/summary.ejs

}